module.exports = __webpack_public_path__ + "img/button_presnaZhoda_on.136f2b7e.svg";